/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/utilitiesModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:09:34 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Tue Dec 18 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import uiRouter from 'angular-ui-router';
import template from './views/sessionSetup.html';
import controller from './controllers/sessionSetupController';
import './sessionSetup.scss';

import _ from "underscore"
var module = angular.module('SessionSetupModule', [
    uiRouter
    //import modules
]).controller('sessionSetup', controller);






// WEBPACK FOOTER //
// ./src/app/utilities/sessionSetup/sessionSetupModule.js